import watch   from "redux-watch";
import isEqual from 'is-equal';
import ControllerBase   from './controller_base';
import { api } from 'apps/api';
import { save, destroy }        from "apps/actions/common";
// import { APPROVAL_CLICK_STAMP } from 'apps/events';

export default class ConnectController extends ControllerBase {
  create(payload){
    App.store.dispatch(save(payload));
  }
  destroy(payload){
    App.store.dispatch(destroy(payload));
  }
}
